// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"uxu0lrXLnSuz6bO34zYZ","bodyText":"dZnYx5Q8bkYGbYOvSQ5G","logoWrapper":"oVFSL9kKkkv0HzlbqWGE"};